
import Square from './Square.vue';
export default {
  name: 'Loader',
  components: { Square },
  props: {
    loadingTermValue: {
      type: String,
      default: 'Loading',
    },
  },
};
